import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, first, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { AppSettings } from '../enums/app-settings.enum';
import { AddonModel } from '../models/addon-model';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root',
})
export class PlanService {
  private POSTPAID_RESPONSE?: AddonModel;
  private PREPAID_RESPONSE?: AddonModel;
  private VISITOR_LINE_RESPONSE?: AddonModel;
  private CONTROL_LINE_RESPONSE?: AddonModel;
  private E_LIFE_RESPONSE?: AddonModel;
  private TV_RESPONSE?: AddonModel;
  private CALLS_RESPONSE?: AddonModel;

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(private http: HttpClient, private UTS: UtilitiesService) {}

  public getPostpaid(): Observable<any> {
    if (this.POSTPAID_RESPONSE)
      return this.convertObjectInObservable(this.POSTPAID_RESPONSE);
    return this.getProductsByCategory(AppSettings.POSTPAID);
  }

  public getPrepaid(): Observable<any> {
    if (this.PREPAID_RESPONSE)
      return this.convertObjectInObservable(this.PREPAID_RESPONSE);
    return this.getProductsByCategory(AppSettings.PREPAID);
  }

  public getVisitorLine(): Observable<any> {
    if (this.VISITOR_LINE_RESPONSE)
      return this.convertObjectInObservable(this.VISITOR_LINE_RESPONSE);
    return this.getProductsByCategory(AppSettings.VISITOR_LINE);
  }

  public getControlLine(): Observable<any> {
    if (this.CONTROL_LINE_RESPONSE)
      return this.convertObjectInObservable(this.CONTROL_LINE_RESPONSE);
    return this.getProductsByCategory(AppSettings.CONTROL_LINE);
  }

  public getELife(): Observable<any> {
    if (this.E_LIFE_RESPONSE)
      return this.convertObjectInObservable(this.E_LIFE_RESPONSE);
    return this.getProductsByCategory(AppSettings.E_LIFE);
  }

  public getTV(): Observable<any> {
    if (this.TV_RESPONSE)
      return this.convertObjectInObservable(this.TV_RESPONSE);
    return this.getProductsByCategory(AppSettings.TV);
  }
  public getCalls(): Observable<any> {
    if (this.CALLS_RESPONSE)
      return this.convertObjectInObservable(this.CALLS_RESPONSE);
    return this.getProductsByCategory(AppSettings.CALLS);
  }
  private convertObjectInObservable(D: AddonModel): Observable<any> {
    const OBS = new Observable<any>((O) => {
      O.next(D);
      O.complete();
    });
    return OBS;
  }

  private getProductsByCategory(categoryId: string = ''): Observable<any> {
    const L: string = this.UTS.getLocaleLanguage();
    const iADF: number = AppSettings.IS_APPLY_DEFAULT_FILTERS;
    const C: string = categoryId;
    const NS: string = AppSettings.NAVIGATION_STATE;
    const N: string = AppSettings.NO;
    const payload = { categoryId: C, navigationState: NS, No: N ,Nrpp:'8', type: "Addon"};
    return this.http.post(
      `${
        environment.BASE_URL
      }/getProductsByCategory?locale=${L}&isApplyDefaultFilters=${
        iADF == 1 ? true : false
      }`,
      payload,
      this.httpOptions
    );

  }
  getProductDetails(obj:any) {
    if(obj.commerceItemCategory){
      return this.http.get(
        `${environment.BASE_URL}/getProduct/`+obj.productId,
        this.httpOptions
      );
    }else if(obj.commerceItemType == 'etsElifeSku'){
      return this.http.get(
        `${environment.BASE_URL}/elife/getHomePlanProduct/`+obj.productId,
        this.httpOptions
      );
    }else{
    return this.http.get(
      `${environment.BASE_URL}/getPostPaidPlanProduct/`+obj.productId,
      this.httpOptions
    );
    }
  }
  bannerImage(cat: string) {
    return this.http.get(
      `${environment.BASE_URL}/getBccTexts/buyandget.${cat}.cms.herobanner/`,
      this.httpOptions
    );
  }
  getTabs(cat: string) {
    return this.http.get(
      `${environment.BASE_URL}/getBccTexts/buyandget.${cat}.cms.tabs/`,
      this.httpOptions
    );
  }

  getNumbersListForBookYourNumber(payload) {
    return this.http.post(
      `${environment.BASE_URL}/getNumbersListForBookYourNumber`,
      payload,
      this.httpOptions
    );
  }
  getMandatoryAddons(skuId) {
    return this.http.get(
      `${environment.BASE_URL}/getMandatoryAddon/${skuId}`,this.httpOptions);
	}
  reserveNumber(s,n) {
    return this.http.get(
      `${environment.BASE_URL}/reserveNumber?numberCategory=${s}&number=${n}`,
      this.httpOptions
    );
  }

  getFreebie(s){
    return this.http.get(
      `${environment.BASE_URL}/getFreebie/${s}`,
      this.httpOptions
    );
  }

  getPostPaidPlanProduct(p){
    return this.http.get(
      `${environment.BASE_URL}/getPostPaidPlanProduct/${p}`,
      this.httpOptions
    );
  }

  getPlanSkuForBuyGetCoreProp(p){
    return this.http.get(
      `${environment.BASE_URL}/getPlanSkuForBuyGetCoreProp/${p}`,
      this.httpOptions
    );
  }

  getProduct(p){
    return this.http.get(
      `${environment.BASE_URL}/getProduct/${p}`,
      this.httpOptions
    );
  }

  getPlanSku(p){
    return this.http.get(
      `${environment.BASE_URL}/getPlanSku/${p}`,
      this.httpOptions
    );
  }

  getBccTexts(k){
    return this.http.get(
      `${environment.BASE_URL}/getBccTexts/${k}/`,
      this.httpOptions
    );
  }

  getBccTextsGetRepoConfig(k){
    return this.http.get(
      `${environment.BASE_URL}/getBccTextsGetRepoConfig/${k}/`,
      this.httpOptions
    );
  }

  getSkuKeyBenefits(k){
    return this.http.get(
      `${environment.BASE_URL}/skuKeyBenefits/${k}`,
      this.httpOptions
    );
  }

  initializeChangePlanRequest(request: any) : Observable<any> {
    return this.http
      .post(environment.BASE_URL + "/initializeMobileChangePlanRequest", request, {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
          })
      }).pipe(tap((res:any)=>{
         sessionStorage.setItem('cpSecurityToken',res?.changePlan?.securityToken);
         sessionStorage.setItem('changePlanData', JSON.stringify(res?.changePlan));
      }),catchError((err:any)=>{
        sessionStorage.removeItem('cpSecurityToken');
        sessionStorage.removeItem('changePlanData');
         return throwError(err);
      }));
  }

  changePlanUpdateDetails(updateRequest: any) : Observable<any> {
  let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    // sessionStorage.setItem('cpSecurityToken',changePlanSecurityToken);
    return this
      .http.post(environment.BASE_URL  + "/updateChangePlanRequest", updateRequest, options).pipe(finalize(()=>{
        // sessionStorage.removeItem('cpSecurityToken')
      }));
  }

  changePlan(request: any) : Observable<any> {
    // sessionStorage.setItem('cpSecurityToken',changePlanSecurityToken);
    return this.http
      .post(environment.BASE_URL + "/updateChangePlanRequest", request, {

        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            // 'cpSecurityToken': changePlanSecurityToken
          })
      }).pipe(finalize(()=>{
        // sessionStorage.removeItem('cpSecurityToken')
      }));
  }
  // host ecare
  submitChangePlanRequest(changePlanId: string) : any {
    return this.http
      .get(environment.BASE_URL + `/submitMobileChangePlanRequest/${changePlanId}`,this.httpOptions);
  }

   //host eshop
  // submitChangePlanRequest(changePlanId: string) : any {
  //   return this.http
  //     .get(environment.BASE_URL + "/submitChangePlanRequest/" + changePlanId,this.httpOptions).pipe(finalize(()=>{
  //       // sessionStorage.removeItem('cpSecurityToken')
  //     }));
  // }

  getChangePlanDetail(accountId:any,changePlanId: string) : any {
    let token =sessionStorage.getItem('cpSecurityToken')
    return this.http
      .get(environment.BASE_URL + `/getMobileChangePlanDetails/${accountId}/${changePlanId}?token=${token}`, {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
          })
      }).pipe(finalize(()=>{
        // sessionStorage.removeItem('cpSecurityToken')
      }));
  }

  updateConcentForCreditCheck(request) : any {
    let token =sessionStorage.getItem('cpSecurityToken')
    return this.http
      .post(environment.BASE_URL + `/updateConsentChangePlanRequest`, request, {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'cpSecurityToken': token
          })
      }).pipe(finalize(()=>{
        // sessionStorage.removeItem('cpSecurityToken')
      }));
  }

  creditCheck(changePlanId) : any {
    // sessionStorage.setItem('cpSecurityToken',changePlanSecurityToken);
    return this.http
      .get(environment.BASE_URL + `/creditCheckChangePlanRequest/${changePlanId}`, {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            // 'cpSecurityToken': changePlanSecurityToken
          })
      }).pipe(finalize(()=>{
        // sessionStorage.removeItem('cpSecurityToken')
      }));
  }

  getSavedCreditCards() : any {
    // sessionStorage.setItem('cpSecurityToken',changePlanSecurityToken);
    return this.http
      .post(environment.BASE_URL + `/elife/getSavedCreditCards`, {}, {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            // 'cpSecurityToken': changePlanSecurityToken
          })
      }).pipe(finalize(()=>{
        // sessionStorage.removeItem('cpSecurityToken')
      }));
  }

  changePlanUpdateCountryId(updateRequest: any) : Observable<any> {
    return this
    .http.post(environment.BASE_URL + "/updateChangePlanCountryRequest", updateRequest, this.httpOptions).pipe(finalize(()=>{
        // sessionStorage.removeItem('cpSecurityToken')
      }));
    }

    updatePaymentChangePlanRequest(request) : any {
      // sessionStorage.setItem('cpSecurityToken',changePlanSecurityToken);
      return this.http
        .post(environment.BASE_URL + `/updatePaymentChangePlanRequest`, request, {
          headers: new HttpHeaders({
              'Content-Type': 'application/json',
              // 'cpSecurityToken': changePlanSecurityToken
            })
        }).pipe(finalize(()=>{
          // sessionStorage.removeItem('cpSecurityToken')
        }));
    }

    changePlanUploadDocument(uploadDocumentRequest: any) : Observable<any> {
      //  sessionStorage.setItem('cpSecurityToken',changePlanSecurityToken);
      return this
        .http.post(environment.BASE_URL + "/uploadDocumentChangePlanRequest", uploadDocumentRequest, {
          headers: new HttpHeaders({
              'Content-Type': 'application/json'

            })
        });
    }

    getMustKnowDetails() : any {
      return this.http
        .get(environment.BASE_URL + `/getPlans`,this.httpOptions);
    }

    getConfigurableList() : any {
      return this.http
        .get(environment.BASE_URL + `/getConfigurableSku`,this.httpOptions);
    }
    getOnlineRechargeList() : any {
      return this.http
        .get(environment.BASE_URL + `/getRechargeList`,this.httpOptions);
    }
}
